import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'react-phone-number-input';
import { Label, Container, Content } from './styles';

const Input = function ({ label, value, onChange, error, ...otherProps }) {
  return (
    <Container>
      <Content>
        <Label>{`${label} `}</Label>
        <PhoneInput
          international
          name="phone"
          value={value}
          onChange={onChange}
          placeholder="+99 99 99999 9999"
          flagComponent={() => null}
          countrySelectComponent={() => null}
          numberInputProps={{ className: error ? 'error' : undefined }}
          {...otherProps}
        />
      </Content>
      {!!error && <Label error={error}>Invalid phone number</Label>}
    </Container>
  );
};

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  label: PropTypes.string,
};

export default Input;
